import {
  TRANSFORM_IMAGE,
  REQUEST_UNLINK_IMAGE,
  RECEIVE_UNLINK_IMAGE_SUCCESS,
  RECEIVE_UNLINK_IMAGE_FAILURE,
} from '../actions/actionTypes';

import initialState from './initialState';

export default function imageEditorReducer(state = initialState.imageEditorData, action) {
  switch (action.type) {
    case TRANSFORM_IMAGE:
      return Object.assign({}, state, {
        pageContent: action.pageContent,
        pageId: action.pageId,
      });
    case REQUEST_UNLINK_IMAGE:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case RECEIVE_UNLINK_IMAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        status: action.status,
        lastUpdated: action.receivedAt,
      };
    case RECEIVE_UNLINK_IMAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    default:
      return state;
  }
}
